import React from 'react';
import { Field } from 'formik';
import Label from './Label';
import Error from './Error';
import classNames from 'classnames';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faEye, faEyeSlash} from '@fortawesome/free-solid-svg-icons';

const PasswordField = ({ name, label, required, validate = value => undefined }) => {
  const [type, setType] = React.useState('password');

  return (
    <div className='form-group'>
      <Label required={required}>{label}</Label>
      <div className='input-group'>
        <Field name={name} validate={validate}>
          {({ field }) => <input {...field} type={type} required={required} className='form-control'/>}
        </Field>
        <div
          style={{ opacity: '.7' }}
          className='input-group-append'
          onClick={() => (type === 'password' ? setType('text') : setType('password'))}
        >
          <span className={classNames('input-group-text bg-white', { 'text-primary': type === 'text' })}>
            <FontAwesomeIcon icon={type === 'text' ? faEye : faEyeSlash} />
          </span>
        </div>
      </div>
      <Error name={name}/>
    </div>
  );
};

export default PasswordField;
